module.exports = __webpack_public_path__ + "media/bootstrap-icons/bank2-c07702a2.svg";